<div fxLayout="column"  class="navbarSecretaire">
  <div fxLayout="row" fxLayoutAlign="center center">
    <button class="navSecretaireButton"><h4>Nouvelle arrivée<mat-icon>add</mat-icon></h4></button>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center">
    <button class="navSecretaireButton"><h4>Nouveau depart<mat-icon>add</mat-icon></h4></button>
  </div>
</div>
